export const streetViewApiMetadataUrl = 'https://maps.googleapis.com/maps/api/streetview/metadata?'
export const streetViewApiUrl = 'https://maps.googleapis.com/maps/api/streetview?'
